import config from "@/common/config";

import ApiService from "./api.service";

export default {
  VERSION: config.api.versions.v2,

  /**
   * @param {string} word
   * @param {string[]} methodIds
   */
  suggestions(word, methodIds) {
    return ApiService.post(
      "word-completion/get",
      {
        word,
        methodIds
      },
      this.VERSION
    );
  },

  /**
   * @param {string} uuid
   * @param {string} engine
   * @param {Number} index
   * @param {string} selectedWord
   */
  logSelection(uuid, engine, index, selectedWord) {
    return ApiService.post(
      "word-completion/log-selection",
      {
        uuid,
        engine,
        index,
        selectedWord
      },
      this.VERSION
    );
  }
};
